/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';

export default [
  {
    name: 'play',
    path: '/play',
    meta: {},
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'play_hall' },
    children: [
      {
        name: 'play_stuff',
        path: '/stuff',
        meta: { tabbar: 'play/me', title: '我的' },
        component: () => import('@/views/play/play-stuff'),
      },
      {
        name: 'play_agreement',
        path: 'agreement',
        meta: { tabbar: 'play/hall', title: '教练须知' },
        component: () => import('@/views/play/agreement.vue'),
      },
      {
        name: 'play_hall',
        path: 'hall',
        meta: { tabbar: 'play/hall', title: '游戏指导' },
        component: () => import('@/views/play/hall'),
      },
      {
        name: 'play_service_search',
        path: 'search',
        meta: { tabbar: 'play/hall', title: '搜索' },
        component: () => import('@/views/play/service_search'),
      },
      {
        name: 'play_me_service',
        path: 'me/service',
        meta: { tabbar: 'play/me', auth: AUTH_STATE.LOGGED_IN, title: '我的指导技能' },
        component: () => import('@/views/play/me_service.vue'),
      },
      {
        name: 'play_service_approve_list',
        path: 'services/approve',
        meta: { tabbar: 'play/me', auth: AUTH_STATE.LOGGED_IN, title: '技能审核列表' },
        component: () => import('@/views/play/service_approve_list.vue'),
      },
      {
        name: 'play_service_approve_detail',
        path: 'services/approve/:id',
        meta: { tabbar: 'play/me', auth: AUTH_STATE.LOGGED_IN, title: '技能审核详情' },
        component: () => import('@/views/play/service_approve_detail.vue'),
      },
      {
        name: 'play_me_service_create',
        path: 'me/service/create',
        meta: { tabbar: 'play/me', auth: AUTH_STATE.LOGGED_IN, title: '选择游戏类型' },
        component: () => import('@/views/play/me_service_create.vue'),
      },
      {
        name: 'play_service_detail',
        path: 'services/detail-:id(\\d+)',
        meta: { tabbar: 'play/hall', auth: null, title: '技能详情' },
        component: () => import('@/views/play/service_detail'),
      },
      {
        name: 'play_service_config',
        path: 'services/config-:id(\\d+)',
        meta: { tabbar: 'play/hall', auth: AUTH_STATE.LOGGED_IN, title: '技能设置' },
        component: () => import('@/views/play/service_config.vue'),
      },
      {
        name: 'play_service_order',
        path: 'services/order-:id(\\d+)',
        meta: { tabbar: 'play/hall', auth: AUTH_STATE.LOGGED_IN, title: '下单' },
        component: () => import('@/views/play/service_order.vue'),
      },
      {
        name: 'play_service_appraise_list',
        path: 'services/detail-:id(\\d+)/appraises',
        meta: { tabbar: 'play/hall', auth: AUTH_STATE.LOGGED_IN, title: '评价列表' },
        component: () => import('@/views/play/service_appraise_list.vue'),
      },
      {
        name: 'play_service_list',
        path: 'services/:engine',
        meta: { tabbar: 'play/hall', title: '订单详情' },
        component: () => import('@/views/play/service_list'),
      },
      {
        name: 'play_manage',
        path: 'services',
        meta: { tabbar: 'play/hall', title: '游戏指导' },
        component: () => import('@/views/play/play-manage.vue'),
      },
      {
        name: 'play_service_appraise_approve',
        path: 'services/appraises/approve',
        meta: { tabbar: 'play/hall', auth: AUTH_STATE.LOGGED_IN, title: '待审核技能评价' },
        component: () => import('@/views/play/service_appraise_list.vue'),
      },
      {
        name: 'play_order_detail',
        path: 'orders/detail-:id(\\d+)',
        meta: { tabbar: 'play/hall', auth: AUTH_STATE.LOGGED_IN, title: '订单详情' },
        component: () => import('@/views/play/order_detail.vue'),
      },
      {
        name: 'play_order_admin',
        path: 'orders/admin/:id?',
        meta: { tabbar: 'play/hall', auth: AUTH_STATE.LOGGED_IN, title: '订单管理' },
        component: () => import('@/views/play/order_admin.vue'),
      },
      {
        name: 'play_order_appraise',
        path: 'orders/detail-:id(\\d+)/appraise',
        meta: { tabbar: 'play/hall', auth: AUTH_STATE.LOGGED_IN, title: '评价' },
        component: () => import('@/views/play/order_appraise'),
      },
      {
        name: 'play_order_complaint',
        path: 'orders/detail-:id(\\d+)/complaint',
        meta: { tabbar: 'play/hall', auth: AUTH_STATE.LOGGED_IN, title: '订单申诉' },
        component: () => import('@/views/play/order_complaint.vue'),
      },
      {
        name: 'play_order_list',
        path: 'orders/:filter',
        meta: { tabbar: 'play/hall', auth: AUTH_STATE.LOGGED_IN, title: '订单详情' },
        component: () => import('@/views/play/order_list.vue'),
      },
    ],
  },
] as RouteConfig[];
